import { Component, ReactNode } from 'react';
import { logger } from '../lib/logger';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logger.error('Error caught by boundary:', { error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="min-h-screen flex items-center justify-center p-4 bg-white">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-[#ef2543] mb-4">
              Une erreur est survenue
            </h2>
            <p className="text-gray-600 mb-4">
              {this.state.error?.message || 'Une erreur inattendue s\'est produite'}
            </p>
            <div className="space-y-4">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-2 bg-[#ef2543] text-white rounded-lg hover:bg-[#ef2543]/80"
              >
                Rafraîchir la page
              </button>
              <p className="text-sm text-gray-500">
                Si le problème persiste, veuillez nous contacter.
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}